import 'jquery';

export const initialize = () => {
  // this file exists strictly for the side effects of importing jquery
};

export default {
  initialize,
};
